import script from "./RequestsFromLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestsFromLanding.vue?vue&type=script&setup=true&lang=js"

import "./RequestsFromLanding.vue?vue&type=style&index=0&id=0a652df6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a652df6"]])

export default __exports__